<template>
    <div class="w-full shrink-0">
        <div class="h-14 flex items-center justify-end w-full">
            <slot></slot>
        </div>
    </div>
</template>
